/**
 * Validates that a redirect path is safe to use for navigation.
 * Only allows relative paths starting with / to prevent open redirect vulnerabilities.
 *
 * @param path - The redirect path to validate (typically from query params)
 * @returns true if the path is a valid relative path, false otherwise
 *
 * @example
 * isValidRedirectPath('/channels/invite/abc') // true
 * isValidRedirectPath('https://evil.com') // false
 * isValidRedirectPath('//evil.com') // false
 */
export const isValidRedirectPath = (path: string | null): path is string => {
  if (!path) return false;
  // Only allow relative paths starting with /
  // Prevent open redirects to external sites
  return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');
};
